/* istanbul ignore file - need to fix flakey tests */
import { useMemo } from 'react';

type TreeNode<TData> = {
  children: TreeNode<TData>[];
  PID: string;
};

export type FlatNode<T> = {
  PID: string;
  parent?: string;
} & T;

export const useFlatTree = <T>(tree?: TreeNode<T>): FlatNode<T>[] =>
  useMemo(() => {
    if (!tree) return [];

    const flattenChildren =
      (parentNode?: TreeNode<T>) =>
      (flatTree: FlatNode<T>[], node: TreeNode<T>): FlatNode<T>[] => {
        const { children, ...nodeWithoutChildren } = node;

        const parent = parentNode?.PID;
        const nodeWithParent = { ...nodeWithoutChildren, parent } as unknown as FlatNode<T>;

        const flatChildren = children.reduce(flattenChildren(node), []);

        return [...flatTree, nodeWithParent, ...flatChildren];
      };

    return tree.children.reduce(flattenChildren(), [] as FlatNode<T>[]);
  }, [tree]);
